import { apiRequestActions } from '@ackee/redux-utils';
import { fetchClosedIncidentsTypes } from './types';

export default apiRequestActions(fetchClosedIncidentsTypes, { isDetailRequest: true });
